export const changeValues = (params, type) => ({
  type,
  payload: params,
});
